import React from "react";
import { Icon } from "../core/Icon.jsx";

// Abschnitt und Blatt heben sich über .erp-nav-item in tokens/base.css hervor. Vorher
// schrieb das Ereignis die Fläche direkt an den DOM-Knoten; wurde die Liste unter dem
// stehenden Zeiger neu aufgebaut — beim Filtern über das Suchfeld der genaue Fall —,
// blieb die verlassene Zeile hell stehen.
export function SidebarNav({ items = [], active, activeSection, collapsed = false, onSelect, onToggleSection, openSections = [], heading = "Navigation", style = {} }) {
  return (
    <div className="nav-scroll" style={{ flex: 1, overflowY: "auto", overflowX: "hidden", padding: "2px 8px 8px", ...style }}>
      {!collapsed && heading ? <div style={{ padding: "8px 12px 4px", fontSize: "var(--fs-11)", color: "var(--fg-9)" }}>{heading}</div> : null}
      {items.map((item) => {
        const open = openSections.indexOf(item.label) >= 0;
        const isActiveSection = item.label === activeSection;
        return (
          <React.Fragment key={item.label}>
            <div title={collapsed ? item.label : undefined} onClick={() => onToggleSection && onToggleSection(item.label)} className="erp-nav-item" style={{
              display: "flex", alignItems: "center", gap: 12, marginTop: 3, padding: "7px 12px", borderRadius: "var(--r-popover)",
              background: "var(--nav-item-hot-bg, transparent)", color: isActiveSection ? "var(--ac-blue)" : "var(--fg-3)",
              fontWeight: isActiveSection ? "var(--fw-semibold)" : "var(--fw-regular)", cursor: "pointer",
            }}>
              <span style={{ flex: "none", display: "flex", color: isActiveSection ? "var(--ac-blue)" : "var(--ico-nav)" }}><Icon name={item.icon} size={16} /></span>
              {!collapsed ? <span style={{ flex: 1, fontSize: "var(--fs-13)" }}>{item.label}</span> : null}
              {!collapsed ? <span style={{ display: "flex", color: "var(--fg-9)", transform: "rotate(" + (open ? 90 : 0) + "deg)", transition: "transform var(--dur-normal) ease" }}><Icon name="chevron-right" size={14} /></span> : null}
            </div>
            {open && !collapsed ? (
              <div>
                {(item.children || []).map((c) => {
                  const on = c === active && isActiveSection;
                  return (
                    <div key={c} onClick={() => onSelect && onSelect(item.label, c)} style={{ display: "flex", alignItems: "stretch", marginLeft: 20, cursor: "pointer" }}>
                      <span style={{ flex: "none", width: 2, display: "flex" }}><span style={{ width: on ? 2 : 1, background: on ? "var(--fg-1)" : "var(--line-c)", borderRadius: 1, alignSelf: "stretch" }} /></span>
                      <div className="erp-nav-item" style={{ flex: 1, padding: "6px 12px", marginLeft: 8, borderRadius: "var(--r-tile)", background: "var(--nav-item-hot-bg, transparent)", fontSize: "var(--fs-13)", color: on ? "var(--fg-1)" : "var(--fg-7)", fontWeight: on ? "var(--fw-medium)" : "var(--fw-regular)" }}>{c}</div>
                    </div>
                  );
                })}
              </div>
            ) : null}
          </React.Fragment>
        );
      })}
    </div>
  );
}
